import React from 'react';
import { useTranslation } from 'react-i18next';
import { Props } from './ClearButton.model';
import * as S from './ClearButton.styles';

export const ClearButton: React.FC<Props> = ({
  onClear,
  label,
  disabled = false,
  kind = 'secondary',
}) => {
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled && onClear) {
      onClear();
    }
  };

  return (
    <S.StyledClearButton
      kind={kind}
      onClick={handleClick}
      disabled={disabled}
      type='button'
    >
      {label || t('other.clearAll')}
    </S.StyledClearButton>
  );
};

export default ClearButton;
